import { handleEmit } from ".";
import { getCurrentContractAddresses } from "../../configs/address";
import ABI from "src/contract-logic/abis/BoxSaleABI.json";
import { getWeb3Sender, web3Reader } from "../../wallet-connection";

const { BOX_SALE } = getCurrentContractAddresses();
var contractReader = null;
var contractSender = null;

function getContractReader() {
  if (!contractReader) contractReader = new web3Reader.eth.Contract(ABI, BOX_SALE);
  return contractReader;
}

function getContractSender() {
  const web3Sender = getWeb3Sender();
  if (!contractSender) {
    contractSender = new web3Sender.eth.Contract(ABI, BOX_SALE);
  }

  return contractSender;
}

async function getBoxPrice(boxId) {
  const res = await getContractReader().methods.getBoxPrice(boxId).call();
  return parseInt(res);
}

async function getBalance(address, boxId) {
  const res = await getContractReader().methods.balanceOf(address, boxId).call();
  return parseInt(res);
}

async function getUserBox(address, boxId) {
  const res = await getContractReader().methods.getUserBox(address, boxId).call();
  return parseInt(res);
}

async function getTicketSold() {
  const res = await getContractReader().methods.ticketSold().call();
  return parseInt(res);
}
async function getTicketLimit() {
  const res = await getContractReader().methods.ticketLimit().call();
  return parseInt(res);
}

async function getBoxLimitForId(id) {
  const res = await getContractReader().methods.boxLimitForId(id).call();
  return parseInt(res);
}

async function getBoxSoldForId(id) {
  const res = await getContractReader().methods.boxSoldForId(id).call();
  return parseInt(res);
}

async function getPresalePrice() {
  const res = await getContractReader().methods.preSaleTicketPrice().call();
  return parseInt(res);
}

async function getTicketInBox(boxId) {
  const res = await getContractReader().methods.getTicketOfBox(boxId).call();
  return parseInt(res);
}

async function buyBox(dispatch, address, amount, boxId) {
  const emit = await getContractSender().methods.buyBox(address, amount, boxId).send({ from: address });
  handleEmit(dispatch, emit, "Buy Box");
  return await emit;
}

async function buyPresaleTicket(dispatch, address, amount) {
  const emit = await getContractSender().methods.buyPresaleTicket(address, amount).send({ from: address });
  handleEmit(dispatch, emit, "Buy Presale Ticket");
  return await emit;
}

async function openBox(dispatch, address, id, amount) {
  const emit = await getContractSender().methods.openBox(address, id, amount).send({ from: address });
  handleEmit(dispatch, emit, "Open Box");
  return await emit;
}

async function openAllBox(dispatch, address) {
  const emit = await getContractSender().methods.openAllBox(address).send({ from: address });
  handleEmit(dispatch, emit, "Open All Box");
  return await emit;
}

export default {
  ADDRESS: BOX_SALE,
  ABI,
  getBoxPrice,
  getBalance,
  buyBox,
  getPresalePrice,
  buyPresaleTicket,
  getTicketInBox,
  openBox,
  openAllBox,
  getUserBox,
  getTicketLimit,
  getTicketSold,
  getBoxLimitForId,
  getBoxSoldForId,
};
